
import { Components, Theme } from "@mui/material";

export default {
  MuiDialog: {
    styleOverrides: {
      paper: {
        borderRadius: 10,
        minWidth: 500
      }
    }
  },
  MuiDialogTitle: {
    styleOverrides: {
      root: {
        width: "100%",
        padding: "20px 30px",
        textTransform: "uppercase",
        fontWeight: 600,
        fontSize: 12,
        letterSpacing: "0.1em",
      },
    }
  },
  MuiDialogContent: {
    styleOverrides: {
      root: {
        padding: "24px 30px"
      }
    }
  },
  MuiDialogActions: {
    styleOverrides: {
      root: {
        padding: "24px 30px"
      }
    }
  }
} as Components<Omit<Theme, "components">>;